<i18n src="./resources/locales.json"></i18n>

<template>
  <div>
    <div class="inset-fade-effect" :dark="$vuetify.theme.dark" />
    <div ref="container" class="d-flex flex-column ecs-help-content custom-scrollbar" @scroll="onScroll">
      <h1 class="ecs-help-title">{{ title }}</h1>
      <!-- eslint-disable vue/no-v-html -->
      <div id="help_content_container" v-html="content" />
    </div>
    <transition name="help-fab-fade">
      <v-btn
        v-show="isScrollToTopVisible"
        class="mx-2 help-fab"
        color="accent"
        fab
        small
        :ripple="false"
        @click="handleScrollToTop"
      >
        <v-icon>{{ 'mdi-chevron-up' }}</v-icon>
      </v-btn>
    </transition>
  </div>
</template>

<script>
import HelpService from '@/services/helpService';

export default {
  name: 'EcsHelpPage',

  data() {
    return {
      title: '',
      content: '',
      isScrollToTopVisible: false
    };
  },

  created() {
    this.$root.$on('get-help-content', this.getHelpContent);
  },
  beforeDestroy() {
    this.$root.$off('get-help-content', this.getHelpContent);
  },

  updated() {
    this.updateExternalLinkTargets();
  },

  methods: {
    async getHelpContent(documentId) {
      const content = await HelpService.getHelpDocumentById(documentId).catch(() => {
        this.$root.$emit('snackbar-message', {
          message: this.$t('errors.failRetrievingDocument'),
          type: 'error'
        });
      });
      if (!content) {
        return;
      }

      this.title = content.data.title;
      this.content = content.data.body.anonymous_export_view.value;
      this.handleScrollToTop();
    },

    onScroll({ target }) {
      this.isScrollToTopVisible = target.scrollTop > 200;
    },

    handleScrollToTop() {
      if (!this.$refs.container) {
        return;
      }

      this.$refs.container.scrollTop = 0;
      this.isScrollToTopVisible = false;
    },

    // Updates links to open in a new tab/window
    updateExternalLinkTargets() {
      const helpContentContainer = document.getElementById('help_content_container');
      const links = helpContentContainer.getElementsByTagName('a');
      links.forEach(link => {
        if (link.hostname.includes('support.evolveip.net')) {
          link.setAttribute('target', '_blank');
        }
      });
    }
  }
};
</script>

<style scoped>
.ecs-help-content {
  height: calc(100vh - 128px);
  padding-right: 16px;
  padding-left: 16px;
}

.ecs-help-content >>> h1 {
  margin-top: 16px;
  margin-bottom: 8px;
}

.ecs-help-content >>> h2,
.ecs-help-content >>> h3,
.ecs-help-content >>> h4 {
  margin-top: 8px;
  margin-bottom: 8px;
}

.ecs-help-title {
  margin: 8px 0 0 0 !important;
}

.ecs-help-content >>> ul,
.ecs-help-content >>> ol {
  margin-bottom: 16px;
}

.ecs-help-content >>> ul.toc-indentation {
  margin-bottom: 0 !important;
}

.ecs-help-content >>> ol ol {
  list-style-type: lower-latin;
  margin-bottom: 0;
}

.ecs-help-content >>> ol ol ol {
  list-style-type: lower-roman;
  margin-bottom: 0;
}

.ecs-help-content >>> img {
  max-width: 100%;
  height: auto;
}

.ecs-help-content >>> .error {
  display: none;
}

.help-fab {
  position: fixed;
  right: 4px;
  bottom: 60px;
  z-index: 101;
}

.help-fab-fade-enter-active,
.help-fab-fade-leave-active {
  transition: all 250ms;
}

.help-fab-fade-enter,
.help-fab-fade-leave-to {
  opacity: 0;
  transform: scale(0);
}
</style>
